import Work1 from "../../assets/native-jobs.png";
import Work2 from "../../assets/cryptoverse.png";
import Work3 from "../../assets/travel.png";
import Work4 from "../../assets/blog-1.svg";
import Work5 from "../../assets/blog-2.svg";

const Menu = [
	{
		id: 1,
		image: Work1,
		title: "DriveThru",
		category: ["Frontend", "React"],
		repositoryUrl: ""
	},
	{
		id: 2,
		image: Work2,
		title: "Browser Extension",
		category: ["Frontend", "React"],
		url: "",
		repositoryUrl: ""
	},
	{
		id: 3,
		image: Work3,
		title: "Travel App",
		category: ["Frontend"],
		url: "",
		repositoryUrl: ""
	},
	{
		id: 4,
		image: Work4,
		title: "Travel App Backend",
		category: ["Backend"],
		url: "",
		repositoryUrl: ""
	},
	{
		id: 5,
		image: Work5,
		title: "Trip-tastic",
		category: ["Full Stack"],
		url: "https://trip-tastic-sooty.vercel.app/",
		repositoryUrl: ""
	}
];

export default Menu;
